<script lang="ts">
export type SellPageSuccessBlockProps = {
    title: string;
    description: string;
    guestTitle: string;
    guestDescription: string;
    guestCta: string;
};
</script>
<script setup lang="ts">
import { ROUTE_NAMES } from '~/constants/routes';

// PROPS
defineProps<SellPageSuccessBlockProps>();

// COMPOSABLES
const { isLoggedIn } = useAuthUtils();
const localePath = useLocalePath();
</script>

<template>
    <div class="flex flex-col gap-6 rounded-xl bg-white p-6 text-center">
        <div class="my-auto flex flex-col gap-6">
            <div class="flex flex-col gap-2">
                <h3 class="text-2xl font-bold">{{ title }}</h3>
                <p>{{ description }}</p>
            </div>
            <template v-if="!isLoggedIn">
                <USeparator />
                <div class="flex flex-col gap-2">
                    <h3 class="text-lg font-semibold">{{ guestTitle }}</h3>
                    <p>{{ guestDescription }}</p>
                    <UButton class="w-auto" :label="guestCta" :to="localePath(ROUTE_NAMES.LOGIN)" size="xl" block />
                </div>
            </template>
        </div>
    </div>
</template>
